import Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import { fetchData, fetchShopData } from "../Cpanel/Components/Utilities";
import SelectFormat from "../Landing/Components/FormOptions/SelectFormat";
import {
  ShopContext,
  ShopListContext,
} from "../StateManagement/Contexts/ShopContext";
import { DropDownFormat } from "../Landing/Components/FormOptions/DropDownFormat";
import { Controller, useForm } from "react-hook-form";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { InputFormat } from "../Landing/Components/FormOptions/InputFormat";
import Logo from "../Assets/images/logoh.png";
import { PanelContainer } from "../Cpanel/Components/PanelContainer";
const PanelShop = () => {
  const statusOptions = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
  ];
  const [shopInfo, setshopInfo] = useState([]);
  const { shopData } = useContext(ShopContext);
  // const [shopList, setShopList] = useState([]);

  const mapOptions = (apiResponse) => {
    return apiResponse?.map((item) => ({
      value: item.ShopId,
      label: item.Title,
    }));
  };
  const shopTypeIdToValue = (shopType) => {
    if (shopType === 1) {
      return "اینترنتی";
    } else if (shopType === 2) {
      return "حضوری";
    }
  };
  const defaultValues = {};
  const {
    handleSubmit,
    watch,
    reset,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });

  console.log();
  const onSubmit = (data) => {};
  return (
    <PanelContainer title={"اطلاعات فروشگاه"}>
      {shopData?.type ? (
        shopData?.type === 1 ? (
          <div dir="rtl" className="">
            <Row>
              <Col className=" col-12 col-lg-6">
                <Form.Label className="fw-bold pb-1">
                  {"لوگو فروشگاه"}
                </Form.Label>
                <img
                  id="avatar"
                  className="avatar"
                  onClick={() => document.getElementById("fileInput").click()}
                  alt="avatar"
                  src={!Logo ? `${shopData?.url}` : Logo}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6 pb-2">
                <div className="m-2 p-2 bg-light rounded  d-flex justiy-content-between align-items-center gap-4  lg:w-50">
                  <label className="fw-bold">نام فروشگاه</label>
                  <label className="">{shopData?.Title}</label>
                </div>
              </Col>
              <Col className=" col-12 col-lg-6 pb-2">
                <div className="m-2 pb-2 bg-light rounded p-2 d-flex justiy-content-between align-items-center gap-4 lg:w-50">
                  <label className="fw-bold">نوع فروشگاه</label>
                  <label>{shopTypeIdToValue(shopData?.type)}</label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6 ">
                <div className="m-2 pb-2 bg-light rounded p-2 d-flex justiy-content-between align-items-center gap-4 lg:w-50">
                  <label className="fw-bold">میزان کش بک </label>
                  <label>{shopData?.MinimumCashBack}</label>
                </div>
              </Col>
              <Col className=" col-12 col-lg-6 pb-2">
                <div className="m-2 pb-2 bg-light rounded p-2 d-flex justiy-content-between align-items-center gap-4 lg:w-50">
                  <label className="fw-bold">سایت فروشگاه</label>
                  <label>{shopData?.WebSite}</label>
                </div>
              </Col>
            </Row>
          </div>
        ) : (
         (
            <Row>
              <Col>type = 2</Col>
              <Col className=" col-12 col-lg-6">
                <Form.Label className="fw-bold pb-1">
                  {"لوگو فروشگاه"}
                </Form.Label>
                <img
                  id="avatar"
                  className="avatar"
                  onClick={() => document.getElementById("fileInput").click()}
                  alt="avatar"
                  src={!Logo ? `${shopData?.url}` : Logo}
                />
              </Col>
            </Row>
          )
        )
      ) : (
        <div>
          <h5>
            <span className="text-danger fs-4 fw-bold "> * </span>لطفا فروشگاه
            تان را از منوی بالا انتخاب کنید{" "}
          </h5>
        </div>
      )}
    </PanelContainer>
  );
};

export default PanelShop;
